<template>
  <div class="admin-login">
    <el-card class="login-card">
      <div class="login-brand">
        <img :src="brandLogo" alt="宸镜AI" class="login-logo" />
        <h2>宸镜AI · 管理后台</h2>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px" @keyup.enter.native="handleLogin">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" placeholder="请输入管理员用户名" prefix-icon="el-icon-user" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width: 100%" @click="handleLogin">登录</el-button>
        </el-form-item>
        <p class="apply-link"><router-link to="/channel/apply">渠道商入驻申请</router-link></p>
      </el-form>
    </el-card>
    <el-dialog
      title="选择要进入的后台"
      :visible.sync="chooser"
      width="560px"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <div class="pick">
        <button type="button" @click="enter('/hq/board')">
          <b>代理商管理后台</b>
          <span>渠道组织、代金券、分账结算、保证金和报备</span>
        </button>
        <button type="button" @click="enter(siteTarget)">
          <b>官网管理后台</b>
          <span>会员、内容、订单和系统设置</span>
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { adminLogin } from '@/api/admin'
import { brandLogoUrl, BRAND_ADMIN_TITLE } from '@/utils/brand'

export default {
  name: 'AdminLogin',
  data() {
    return {
      loading: false,
      chooser: false,
      siteTarget: '/admin/dashboard',
      brandLogo: brandLogoUrl('light'),
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    document.title = BRAND_ADMIN_TITLE
  },
  methods: {
    ...mapActions(['setAdminAuth']),
    handleLogin() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          const result = await adminLogin(this.form)
          await this.setAdminAuth({
            token: result.token,
            adminInfo: {
              adminId: result.adminId,
              username: result.username,
              realName: result.realName,
              roleCodes: result.roleCodes
            },
            menus: result.menus || []
          })
          this.$message.success('登录成功')
          const roles = result.roleCodes || []
          const channelUser = roles.indexOf('CHANNEL') >= 0 && roles.indexOf('SUPER_ADMIN') < 0
          const redirect = this.$route.query.redirect
          if (channelUser) {
            const target = typeof redirect === 'string' && redirect.indexOf('/partner/') === 0 ? redirect : '/partner/board'
            this.$router.replace(target)
            return
          }
          if (typeof redirect === 'string' && redirect.indexOf('/hq/') === 0) {
            this.$router.replace(redirect)
            return
          }
          if (typeof redirect === 'string' && redirect.indexOf('/admin/') === 0 && redirect.indexOf('/admin/channel') !== 0 && redirect !== '/admin/dashboard') {
            this.siteTarget = redirect
          }
          this.chooser = true
        } catch (e) {
          // 错误由 request 拦截器统一弹框
        } finally {
          this.loading = false
        }
      })
    },
    enter(path) {
      this.chooser = false
      this.$router.replace(path)
    }
  }
}
</script>

<style scoped>
.admin-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1e3a5f 0%, #2d5a87 100%);
}
.login-card {
  width: 400px;
}
.login-brand {
  text-align: center;
  margin-bottom: 24px;
}
.login-logo {
  display: block;
  height: 40px;
  width: auto;
  max-width: 220px;
  margin: 0 auto 12px;
  object-fit: contain;
}
.login-brand h2 {
  margin: 0;
  color: #1e3a5f;
  font-size: 18px;
  font-weight: 600;
}
.pick { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.pick button {
  text-align: left;
  border: 1px solid #e7ebf3;
  background: #fff;
  border-radius: 12px;
  padding: 18px 16px;
  cursor: pointer;
}
.pick button:hover { border-color: #f0b429; }
.pick b { display: block; color: #1a2468; font-size: 16px; margin-bottom: 8px; }
.pick span { color: #7b8499; font-size: 12px; line-height: 1.5; }
.apply-link { text-align: center; margin: 0; }
.apply-link a { color: #2f4dbf; font-size: 13px; }
</style>
